// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadSettings from "@insite/client-framework/Store/Context/Handlers/LoadSettings";
import { ThirdPartyScriptSettingsModel } from "@store/Framework/Types/ThirdPartyScriptSettingsModel";
import { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const scriptTagOneTrust = (id: string): HTMLScriptElement => {
    const script = document.createElement("script");
    script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    script.type = "text/javascript";
    script.charset = "UTF-8";
    script.setAttribute("data-domain-script", id);
    document.head.appendChild(script);
    return script;
};

const scriptTagExecuteOptAnon = (): HTMLScriptElement => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerText = "function OptanonWrapper() {}";
    document.head.appendChild(script);
    return script;
};

const mapStateToProps = (state: ApplicationState) => {
    const thirdPartyScriptSettings = getSettingsCollection(state)
        .thirdPartyScriptSettings as ThirdPartyScriptSettingsModel;

    return {
        oneTrustScriptId: thirdPartyScriptSettings?.oneTrustScriptId,
        areSettingsLoaded: state.context.areSettingsLoaded,
        areSettingsLoading: state.context.areSettingsLoading,
    };
};

const mapDispatchToProps = {
    loadSettings,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const OneTrustScript: FC<Props> = ({ oneTrustScriptId, areSettingsLoaded, areSettingsLoading, loadSettings }) => {

    useEffect(() => {
        if (!areSettingsLoaded && !areSettingsLoading) {
            loadSettings();
        }
    }, [areSettingsLoaded, areSettingsLoading, loadSettings]);

    useEffect(() => {
        if (oneTrustScriptId) {
            const scriptOneTrust = scriptTagOneTrust(oneTrustScriptId);
            const scriptOptAnon = scriptTagExecuteOptAnon();

            return () => {
                document.head.removeChild(scriptOneTrust);
                document.head.removeChild(scriptOptAnon);
            };
        }
    }, [oneTrustScriptId]);

    return null;
};

export default connect(mapStateToProps, mapDispatchToProps)(OneTrustScript);
